import Axios from 'axios'
import query from './query'
import cookies from 'cookies-js'
import { DESIRED_LANGUAGE } from './cookies'

const generatingFor = { locale: undefined }
const SUPPORTED = {
  'en-us': 1,
  'en-gb': 1,
  'id-id': 1,
  'ca-es': 1,
  'cy-gb': 1,
  'da-dk': 1,
  'de-de': 1,
  'es-mx': 1,
  'es-es': 1,
  'fr-ca': 1,
  'fr-fr': 1,
  'hr-hr': 1,
  'it-it': 1,
  'lt-lt': 1,
  'nl-nl': 1,
  'pl-pl': 1,
  'pt-br': 1,
  'pt-pt': 1,
  'sk-sk': 1,
  'sl-si': 1,
  'vi-vn': 1,
  'tr-tr': 1,
  'be-by': 1,
  'el-gr': 1,
  'bg-bg': 1,
  'ru-ru': 1,
  'sr-rs': 1,
  'uk-ua': 1,
  'he-il': 1,
  'ar-ar': 1,
  'hi-in': 1,
  'bn-in': 1,
  'pa-in': 1,
  'ko-kr': 1,
  'zh-tw': 1,
  'zh-cn': 1,
  'ja-jp': 1
}

const localeRe = /^[a-z]{2}-[A-Z]{2}/

const origin = () => {
  let loc
  if (window.location.origin) {
    return window.location.origin
  }
  loc = window.location.protocol + '//' + window.location.hostname
  if (window.location.port) {
    loc += ':' + window.location.port
  }
  return loc
}

const looksLikeLanguage = str => {
  let result
  if (typeof str !== 'string') {
    result = false
  } else if (str.length === 5) {
    result = str[2] === '-'
  } else if (str.length === 6) {
    result = str[3] === '-'
  } else {
    result = false
  }
  return result
}

const currentLanguage = () => {
  let path
  path = location.pathname
  path = path.split('/')
  if (path[0] === '') {
    path.shift()
  }
  if (looksLikeLanguage(path[0])) {
    return path[0].toLowerCase()
  }
  return 'en-us'
}

const fixLocale = function(locale) {
  let err
  try {
    if (locale == null) {
      locale = 'en-US'
    }
    locale = locale.split('-')
    locale = (locale[0].toLowerCase()) + '-' + (locale[1].toUpperCase())
    if (!localeRe.test(locale)) {
      locale = 'en-US'
    }
    return locale
  } catch (_error) {
    err = _error
    return 'en-US'
  }
}

const pathnameWithoutLanguage = () => {
  let path
  path = location.pathname
  path = path.split('/')
  if (path[0] === '') {
    path.shift()
  }
  if (looksLikeLanguage(path[0])) {
    path.shift()
  }
  return path.join('/')
}

const makeRedirect = lang => {
  const newQuery = query.extend({
    redirect: true
  })
  return origin() + '/' + lang + '/' + pathnameWithoutLanguage() + '?' + query.stringify(newQuery) + location.hash
}

function getRelativePath(path) {
  let locale = generatingFor.locale
  if (locale && locale !== 'en-US' && !path.includes('//')) {
    locale = locale.toLowerCase()
    path = `/${locale}${path}`
  }
  return path
}

function checkRedirect() {
  if (typeof window === 'undefined') return //no need for this during server side rendering
  let url

  let desiredLanguage = cookies.get(DESIRED_LANGUAGE)

  if (desiredLanguage) {
    desiredLanguage = desiredLanguage.toLowerCase()
  }

  if (desiredLanguage && !SUPPORTED[desiredLanguage.toLowerCase()]) {
    cookies.expire(DESIRED_LANGUAGE)
    return
  }

  const redirect = query.get('redirect')

  const current = currentLanguage()

  if (redirect) {
    return
  }

  if (current !== 'en-us' && !redirect) {
    return
  }

  if (desiredLanguage && desiredLanguage !== current) {
    url = makeRedirect(desiredLanguage)
    window.location = url
    return
  }

  if (!desiredLanguage) {
    Axios.get(origin() + '/api/language?external=true')
      .then(body => {
        const language = body.data.language.toLowerCase()
        if (!SUPPORTED[language]) {
          return
        }
        cookies.set(DESIRED_LANGUAGE, language, {
          expires: Infinity
        })
        if (current === language) {
          return
        }
        url = makeRedirect(language)
        return (window.location = url)
      })
      .catch(err => {
        console.log(err)
      })
  }
}

export { getRelativePath, checkRedirect, generatingFor, currentLanguage, fixLocale }
